export const ASSETS_CDN_BASE = 'https://cdn.block.xyz';

export function cdnAssetURL(path: string) {
  return `${ASSETS_CDN_BASE}${path}`;
}
